import React from 'react'

function Media() {
  return (
    <>
        <div className="isgf_breadcum_media">
            <a href="https://www.facebook.com/IndiaSmartGridF/" className="fa fa-facebook" target="_blank"></a>
            {/* <a href="https://twitter.com/IndiaSmartGridF" className="fa fa-twitter" target="_blank"></a> */}
            <a href="https://twitter.com/IndiaSmartGridF" className='fa' target="_blank" style={{ color: 'white',backgroundColor: 'black' }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style={{ width: '20px', height: '20px', fill: 'white' }}
                >
                    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                </svg>
            </a>
            <a href="https://www.linkedin.com/company/3100677/admin/" className="fa fa-linkedin" target="_blank"></a>
            <a href="https://www.youtube.com/channel/UCgEIWHy1ziq-t86r3Pw-8BQ" className="fa fa-youtube" target="_blank"></a>
            <a href="https://www.flickr.com/photos/indiasmartgridforum/" className="fa fa-flickr" target="_blank"></a>
            <a href="https://www.instagram.com/indiasmartgridforum/" className="fa fa-instagram" target="_blank"></a>
    </div>
    </>
  )
}

export default Media;